var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.92872 0.278417L7.25487 6.32784C7.58171 6.69906 7.58171 7.30093 7.25487 7.67216L1.92872 13.7216C1.60188 14.0928 1.07197 14.0928 0.74513 13.7216C0.41829 13.3504 0.41829 12.7485 0.74513 12.3773L5.47949 7L0.74513 1.62273C0.41829 1.25151 0.41829 0.64964 0.74513 0.278417C1.07197 -0.0928058 1.60188 -0.0928058 1.92872 0.278417Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon_arrow_right.46da41128345404a1ab11d4a42c41e04.svg";
export { ForwardRef as ReactComponent };